export default function CsNetworkLayer() {
  return (
    <h2>Cs Network Layer</h2>
  );
}
